module.exports = __webpack_public_path__ + "img/contact_me_qr.64077ed3.png";